import { render, staticRenderFns } from "./TabRequestAndProgress.vue?vue&type=template&id=47d08d9c&"
import script from "./TabRequestAndProgress.vue?vue&type=script&lang=js&"
export * from "./TabRequestAndProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports